export enum ContractStageEnum {
  'На рассмотрении',
  'Согласован',
  'В работе',
  'Завершен',
  'Закрыт',
  'Расторгнут',
  'Загрузка документов',
}
